module.exports = __webpack_public_path__ + "img/enabled.f55142e1.svg";